import { colorVariantFields, nextVariantKey } from "@/lib/materialColors";
import React from 'react';
import { SimulationSizeColorMatrix } from './SimulationSizeColorMatrix';
import { matrixModel, SIZE_FIELDS } from '@/lib/manufacturingProcessTracking';
import { magicFillQuantities } from '@/lib/constants';

export function ProcessMatrix({ rows, onChange, readOnly, allowAddColors = true }) {
  const model = matrixModel(rows);
  const setCell = (key, value) => {
    const split = key.lastIndexOf('::');
    const color = key.slice(0, split), size = key.slice(split + 2);
    onChange(rows.map((row) => row.color === color ? { ...row, [SIZE_FIELDS[size]]: Math.max(0, Math.floor(Number(value || 0))) } : row));
  };
  return <><SimulationSizeColorMatrix {...model} hideContrasts allowVariants variants={Object.fromEntries(rows.map((row) => [row.color, colorVariantFields(row)]))} readOnly={readOnly} allowAddColors={allowAddColors}
    onChange={setCell}
    onContrastChange={(color, field, value) => onChange(rows.map((r) => r.color === color ? { ...r, [field]: value } : r))}
    onAddColor={(color) => onChange([...rows, { color: nextVariantKey(color, model.colors), garment_color: color, variant_id: crypto.randomUUID(), material_colors: {}, sort_order: rows.length }])}
    onRemoveColor={(color) => onChange(rows.filter((r) => r.color !== color))}
    onFillRow={(color, value) => {
      const filled = magicFillQuantities(color, value);
      onChange(rows.map((r) => r.color === color ? { ...r, ...Object.fromEntries(Object.entries(SIZE_FIELDS).map(([size, field]) => [field, filled[`${color}::${size}`] || 0])) } : r));
    }} />
    {rows.some((row) => row.contrast_1 || row.contrast_2 || row.contrast_3) && <details className="mt-2 text-xs"><summary>Contrastes anteriores conservados</summary>
      {rows.map((row) => <p key={row.color}>{row.color}: {[1,2,3].map((i) => row[`contrast_${i}`] ? `C${i}: ${row[`contrast_${i}`]}` : '').filter(Boolean).join(' · ')}</p>)}
    </details>}</>;
}
